import React from 'react'
import { CardSection, Heading } from './CardSection'
import { Item, UsageItemList } from './Item'

export type ItemsForRegistrationProps = {
  items: Item[]
}

export const ItemsForRegistration = ({ items }: ItemsForRegistrationProps) => {
  return (
    <CardSection>
      <Heading as="h3">登録時に必要なもの</Heading>
      <UsageItemList items={items} />
    </CardSection>
  )
}
